"use client"

import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import { Badge } from "@/components/ui/badge"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import {
  ArrowRight,
  Star,
  Package,
  CreditCard,
  Headphones,
  ChevronLeft,
  ChevronRight,
  Mail,
  Facebook,
  Twitter,
  Youtube,
  Instagram,
} from "lucide-react"
import Image from "next/image"
import Link from "next/link"
import { HeroSlider } from "@/components/hero-slider"
import { ProductCard } from "@/components/product-card"
import { useWishlist } from "@/lib/wishlist-context"
import { useCart } from "@/lib/cart-context"

export default function LuxuryJeffLandingPage() {

  const { items } = useCart()
  const { totalItems: wishlistItems } = useWishlist()

  const [activeTab, setActiveTab] = useState("All")
  const [timeLeft, setTimeLeft] = useState({
    days: 5,
    hours: 12,
    minutes: 30,
    seconds: 25,
  })

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [categories, setCategories] = useState<any[] | null>(null)
  const [products, setProducts] = useState([])

  const [dealProducts, setDealProducts] = useState([])

  const [fetchingTodaysDeals, setFetchingTodaysDeals] = useState(false)

  const [faqs, setFaqs] = useState([])

  const fetchFaqs = async () => {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API}/api/faqs`)
    const data = await res.json()
    console.log(data, 'faqs data')
    if (data) {
      setFaqs(data.faqs || [])
    } else {
      setFaqs([])
    }
  }

  // Countdown timer effect
  useEffect(() => {
    // console.log(items, 'totalItems')
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 }
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 }
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 }
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 }
        }
        return prev
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const fetchDealProducts = async () => {
    try {
      setFetchingTodaysDeals(true)
      // setError(null)

      const res = await fetch(`${process.env.NEXT_PUBLIC_API}/api/products/deals`, {
        method: "GET",
      })

      if (!res.ok) {
        throw new Error(`Failed to fetch deal products: ${res.status}`)
      }

      const data = await res.json()
      setDealProducts(data.products || [])
    } catch (err: any) {
      // setError(err.message || "Something went wrong")
    } finally {
      setFetchingTodaysDeals(false)
    }
  }

  const fetchProducts = async () => {
    try {
      setLoading(true)
      setError(null)

      const res = await fetch(`${process.env.NEXT_PUBLIC_API}/api/products/home`, {
        method: "GET",
      })

      if (!res.ok) {
        throw new Error(`Failed to fetch products: ${res.status}`)
      }

      const data = await res.json()
      setProducts(data.products || [])
    } catch (err: any) {
      setError(err.message || "Something went wrong")
    } finally {
      setLoading(false)
    }
  }
  const fetchHomeCategories = async () => {
    try {
      //setLoading(true)
      //setError(null)

      const res = await fetch(`${process.env.NEXT_PUBLIC_API}/api/products/home_categories`, {
        method: "GET",
      })

      if (!res.ok) {
        throw new Error(`Failed to fetch home categories: ${res.status}`)
      }

      const data = await res.json()
      setCategories(data.categories || [])

    } catch (err: any) {
      //setError(err.message || "Something went wrong")
    } finally {
      //setLoading(false)
    }
  }


  useEffect(() => {

    fetchProducts()

    fetchDealProducts()

    fetchHomeCategories()

    fetchFaqs()



  }, [])

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* Hero Section */}
      <HeroSlider />

      {/* Service Features */}
      <div className="bg-white dark:bg-gray-800 border-t dark:border-gray-700">
        <div className="container mx-auto px-4 py-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-amber-100 dark:bg-amber-900/20 rounded-lg flex items-center justify-center">
                <Package className="h-6 w-6 text-amber-900 dark:text-amber-400" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white">Free Shipping</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">Free shipping for order above ₦20k</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-amber-100 dark:bg-amber-900/20 rounded-lg flex items-center justify-center">
                <CreditCard className="h-6 w-6 text-amber-900 dark:text-amber-400" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white">Flexible Payment</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">Multiple secure payment options</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-amber-100 dark:bg-amber-900/20 rounded-lg flex items-center justify-center">
                <Headphones className="h-6 w-6 text-amber-900 dark:text-amber-400" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white">24x7 Support</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">We support online all days.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Limited Time Offers */}
      <section className="py-16 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <Image
                src="/placeholder.svg?height=500&width=600"
                alt="Fashion Models"
                width={600}
                height={500}
                className="rounded-lg"
              />
            </div>

            <div className="space-y-6">
              <div className="space-y-2">
                <p className="text-gray-600 dark:text-gray-400 font-medium">Limited Time Offers</p>
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white">
                  25% Off All Fashion Favorites - Limited Time!
                </h2>
                <p className="text-gray-600 dark:text-gray-400">
                  Don't miss out on our exclusive limited-time offer. Get 25% off on all your favorite fashion items
                  from our premium collection.
                </p>
              </div>

              <Button className="bg-gradient-to-r from-[#ea580c] to-[#d97706] hover:from-[#dc2626] hover:to-[#ea580c] text-white px-8 py-3">
                Shop Now <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      {/* <section className="py-16 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-3 gap-8">
            {categories.map((cat, idx) => (
              <Card key={idx} className="bg-gray-50 dark:bg-gray-800 border-0">
                <CardContent className="p-8">
                  <div className="space-y-6">
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                        {cat.itemsCount}
                      </p>
                      <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        {cat.title}
                      </h3>
                      {cat.description && (
                        <p className="text-gray-600 dark:text-gray-400 text-sm mb-6">
                          {cat.description}
                        </p>
                      )}
                    </div>

                    <div className="space-y-3">
                      {cat.subcategories.map((sub, i) => (
                        <Link
                          key={i}
                          href={`/shop?category=${cat.title}&subcategory=${sub.name}`}
                          className="block text-gray-700 dark:text-gray-300 hover:text-amber-900 dark:hover:text-amber-400 capitalize"
                        >
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="mt-8">
                    <Image
                      src={cat.image.src}
                      alt={cat.image.alt}
                      width={250}
                      height={300}
                      className="rounded-lg"
                    />
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section> */}


      <section className="py-16 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-3 gap-8">
            {!categories
              ? // Skeleton state
              Array.from({ length: 3 }).map((_, idx) => (
                <Card key={idx} className="bg-gray-50 dark:bg-gray-800 border-0">
                  <CardContent className="p-8 space-y-6">
                    <div>
                      <Skeleton className="h-4 w-20 mb-2" />
                      <Skeleton className="h-6 w-40 mb-4" />
                      <Skeleton className="h-4 w-3/4 mb-6" />
                    </div>

                    <div className="space-y-3">
                      {Array.from({ length: 4 }).map((__, i) => (
                        <Skeleton key={i} className="h-4 w-24" />
                      ))}
                    </div>

                    <div className="mt-8">
                      <Skeleton className="h-[300px] w-[250px] rounded-lg" />
                    </div>
                  </CardContent>
                </Card>
              ))
              : // Actual data
              categories.map((cat, idx) => (
                <Card key={idx} className="bg-gray-50 dark:bg-gray-800 border-0">
                  <CardContent className="p-8">
                    <div className="space-y-6">
                      <div>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                          {cat.itemsCount}
                        </p>
                        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                          {cat.title}
                        </h3>
                        {cat.description && (
                          <p className="text-gray-600 dark:text-gray-400 text-sm mb-6">
                            {cat.description}
                          </p>
                        )}
                      </div>

                      <div className="space-y-3">
                        {cat.subcategories.map((sub, i) => (
                          <Link
                            key={i}
                            href={`/shop?category=${cat.title}&subcategory=${sub.name}`}
                            className="block text-gray-700 dark:text-gray-300 hover:text-amber-900 dark:hover:text-amber-400 capitalize"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    </div>

                    <div className="mt-8">
                      <Image
                        src={cat.image}
                        alt={cat.title}
                        width={250}
                        height={300}
                        className="rounded-lg"
                      />
                    </div>
                  </CardContent>
                </Card>
              ))}
          </div>
        </div>
      </section>


      {/* Our Products Section */}
      <section className="py-16 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-12">
            <div>
              <p className="text-gray-600 dark:text-gray-400 mb-2">Our Products</p>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white">Our Top Seller Products</h2>
            </div>

            <div className="flex gap-2 mt-6 lg:mt-0">
              {["All", "Women", "Men", "Kids"].map((tab) => (
                <Button
                  key={tab}
                  variant={activeTab === tab ? "default" : "outline"}
                  className={
                    activeTab === tab
                      ? "bg-gradient-to-r from-[#ea580c] to-[#d97706] hover:from-[#dc2626] hover:to-[#ea580c] text-white"
                      : "bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600"
                  }
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </Button>
              ))}
            </div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((product, index) => (
              <ProductCard key={index} product={product} showTimer={index === 0} timeLeft={timeLeft} />
            ))}
          </div>
        </div>
      </section>

      {/* Today's Deals */}
      <section className="py-16 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="mb-12">
            <p className="text-gray-600 dark:text-gray-400 mb-2">Today Deals</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white">Deals of the Day</h2>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 mb-12">

            {
              fetchingTodaysDeals ?
                Array.from({ length: 2 }).map((_, index) => (
                  <div
                    key={index}
                    className="border rounded-lg p-4 animate-pulse bg-white shadow-sm"
                  >
                    <div className="h-40 bg-gray-200 rounded mb-4"></div> {/* Image placeholder */}
                    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div> {/* Title placeholder */}
                    <div className="h-3 bg-gray-200 rounded w-1/2 mb-2"></div> {/* Price placeholder */}
                    <div className="h-3 bg-gray-200 rounded w-1/4"></div> {/* Extra info */}
                  </div>
                )) :
                (
                  dealProducts.map((product, index) => (
                    <ProductCard key={product.id} product={product} />
                  ))

                )

            }
          </div>

          {/* Collection Banners */}
          <div className="grid lg:grid-cols-2 gap-8">
            <Card className="bg-gray-100 dark:bg-gray-800 border-0">
              <CardContent className="p-8">
                <div className="grid md:grid-cols-2 gap-6 items-center">
                  <div className="space-y-4">
                    <Badge className="bg-amber-200 text-amber-900 hover:bg-amber-200">Flat 20% Discount</Badge>
                    <h3 className="text-3xl font-bold text-gray-900 dark:text-white">Men's Latest Collection</h3>
                    <p className="text-gray-600 dark:text-gray-400">
                      Explore our newest men's collection featuring contemporary designs and premium quality materials.
                    </p>
                    <Link href="/shop?category=men">
                      <Button className="bg-amber-200 text-amber-900 hover:bg-amber-300">
                        Shop Now <ArrowRight className="ml-2 h-4 w-4" />
                      </Button>
                    </Link>
                  </div>
                  <Image
                    src="/placeholder.svg?height=300&width=250"
                    alt="Men's Collection"
                    width={250}
                    height={300}
                    className="rounded-lg"
                  />
                </div>
              </CardContent>
            </Card>

            <Card className="bg-amber-200 dark:bg-amber-900/20 border-0">
              <CardContent className="p-8">
                <div className="grid md:grid-cols-2 gap-6 items-center">
                  <div className="space-y-4">
                    <Badge className="bg-gradient-to-r from-[#ea580c] to-[#d97706] hover:from-[#dc2626] hover:to-[#ea580c] text-white">Flat 25% Discount</Badge>
                    <h3 className="text-3xl font-bold text-gray-900 dark:text-white">Women's Latest Fashion</h3>
                    <p className="text-gray-600 dark:text-gray-400">
                      Discover the latest trends in women's fashion with our exclusive collection of stylish pieces.
                    </p>
                    <Link href="/shop?category=women">
                      <Button className="bg-gradient-to-r from-[#ea580c] to-[#d97706] hover:from-[#dc2626] hover:to-[#ea580c] text-white">
                        Shop Now <ArrowRight className="ml-2 h-4 w-4" />
                      </Button>
                    </Link>
                  </div>
                  <Image
                    src="/placeholder.svg?height=300&width=250"
                    alt="Women's Fashion"
                    width={250}
                    height={300}
                    className="rounded-lg"
                  />
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Follow Us Section */}
      <section className="py-16 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-gray-600 dark:text-gray-400 mb-2">Follow Us</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white">Follow Us On Instagram</h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {[1, 2, 3, 4, 5].map((item) => (
              <div key={item} className="relative group cursor-pointer">
                <Image
                  src="/placeholder.svg?height=300&width=300"
                  alt={`Instagram post ${item}`}
                  width={300}
                  height={300}
                  className="w-full h-64 object-cover rounded-lg"
                />
                {item === 2 && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center rounded-lg">
                    <Instagram className="h-12 w-12 text-white" />
                  </div>
                )}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors rounded-lg" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between mb-12">
            <div>
              <p className="text-gray-600 dark:text-gray-400 mb-2">Testimonial</p>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white">What Our Clients Say</h2>
            </div>

            <div className="flex gap-2">
              <Button variant="outline" size="sm" className="bg-amber-200 border-amber-200 hover:bg-amber-300">
                <ChevronLeft className="h-4 w-4" />
              </Button>
              <Button
                variant="outline"
                size="sm"
                className="bg-gradient-to-r from-[#ea580c] to-[#d97706] hover:from-[#dc2626] hover:to-[#ea580c] text-white"
              >
                <ChevronRight className="h-4 w-4" />
              </Button>
            </div>
          </div>

          <Card className="max-w-4xl mx-auto border-0 shadow-sm bg-gray-50 dark:bg-gray-800">
            <CardContent className="p-8">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="relative">
                  <div className="absolute -top-4 -left-4 w-12 h-12 bg-amber-200 dark:bg-amber-300 rounded flex items-center justify-center">
                    <span className="text-2xl font-bold text-amber-900">"</span>
                  </div>
                  <Image
                    src="/placeholder.svg?height=400&width=300"
                    alt="Leslie Alexander"
                    width={300}
                    height={400}
                    className="rounded-lg"
                  />
                </div>

                <div className="space-y-6">
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star key={star} className="h-5 w-5 fill-amber-400 text-amber-400" />
                    ))}
                    <span className="ml-2 text-lg font-semibold text-gray-900 dark:text-white">5.0</span>
                  </div>

                  <p className="text-gray-600 dark:text-gray-400 text-lg leading-relaxed">
                    I absolutely love shopping at Luxury Jeff! The quality of their clothing is exceptional, and the
                    customer service is outstanding. Every piece I've purchased has exceeded my expectations in terms of
                    style, comfort, and durability.
                  </p>

                  <div>
                    <h4 className="font-bold text-gray-900 dark:text-white text-lg">Leslie Alexander</h4>
                    <p className="text-gray-600 dark:text-gray-400">Fashion Enthusiast</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-gray-600 dark:text-gray-400 mb-2">FAQ</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white">Questions? Look here.</h2>
          </div>

          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4" defaultValue="item-0">

              {faqs?.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="rounded-lg border-0 shadow-sm bg-white dark:bg-gray-700 data-[state=open]:bg-gradient-to-r data-[state=open]:from-[#ea580c] data-[state=open]:to-[#d97706]"
                >
                  <AccordionTrigger className="px-6 py-4 text-left font-semibold text-[#000] data-[state=open]:text-white dark:text-white hover:no-underline">
                    {f.question}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-4 text-white dark:text-white data-[state=open]:text-white/90">
                    {f.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}




              {/* <AccordionItem value="item-2" className="bg-gradient-to-r from-[#ea580c] to-[#d97706] hover:from-[#dc2626] hover:to-[#ea580c] text-white rounded-lg border-0 shadow-sm">
                <AccordionTrigger className="px-6 py-4 text-left font-semibold hover:no-underline">
                  What payment methods do you accept?
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-amber-100">
                  We accept all major credit cards (Visa, MasterCard, American Express), PayPal, Apple Pay, Google Pay,
                  and bank transfers. All payments are processed securely through our encrypted payment gateway.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-3" className="bg-white dark:bg-gray-700 rounded-lg border-0 shadow-sm">
                <AccordionTrigger className="px-6 py-4 text-left font-semibold text-gray-900 dark:text-white hover:no-underline">
                  Can I track my order after it's been placed?
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-gray-600 dark:text-gray-400">
                  Yes, once your order is shipped, you'll receive a tracking number via email to monitor your package's
                  progress in real-time.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-4" className="bg-white dark:bg-gray-700 rounded-lg border-0 shadow-sm">
                <AccordionTrigger className="px-6 py-4 text-left font-semibold text-gray-900 dark:text-white hover:no-underline">
                  Do you offer customer support?
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-gray-600 dark:text-gray-400">
                  Yes, we offer 24/7 customer support through various channels including phone, email, and live chat.
                  Our dedicated support team is always ready to help you.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-5" className="bg-white dark:bg-gray-700 rounded-lg border-0 shadow-sm">
                <AccordionTrigger className="px-6 py-4 text-left font-semibold text-gray-900 dark:text-white hover:no-underline">
                  What is your return policy?
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-gray-600 dark:text-gray-400">
                  We offer a 30-day return policy for unworn items in original condition with tags attached. Returns are
                  free and easy through our online portal.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-6" className="bg-white dark:bg-gray-700 rounded-lg border-0 shadow-sm">
                <AccordionTrigger className="px-6 py-4 text-left font-semibold text-gray-900 dark:text-white hover:no-underline">
                  How to Create Account?
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-gray-600 dark:text-gray-400">
                  Click on the "Sign Up" button in the top right corner and fill out the registration form with your
                  details. You'll receive a confirmation email to activate your account.
                </AccordionContent>
              </AccordionItem> */}


            </Accordion>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-16 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-gray-600 dark:text-gray-400 mb-2">Our Newsletter</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Subscribe to Our Newsletter to Get Updates to Our Latest Collection
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              Get 20% off on your first order just by subscribing to our newsletter
            </p>
          </div>

          <div className="max-w-md mx-auto">
            <div className="flex gap-2">
              <div className="relative flex-1">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                <Input
                  type="email"
                  placeholder="Enter Email Address"
                  className="pl-10 py-3 border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-white"
                />
              </div>
              <Button className="bg-gradient-to-r from-[#ea580c] to-[#d97706] hover:from-[#dc2626] hover:to-[#ea580c] text-white px-6">Subscribe</Button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-amber-900 text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="space-y-4">
              <Link href="/" className="flex items-center gap-2">
                {/* <div className="w-8 h-8 bg-amber-200 rounded-full flex items-center justify-center text-amber-900 font-bold">
                  L
                </div>
                <span className="text-xl font-bold">Luxury Jeff</span> */}

                <Image src="/logo.png" alt="" width={150}
                  height={50}
                  className="rounded-lg" />


              </Link>
              <p className="text-amber-100 text-sm leading-relaxed">
                Your ultimate destination for premium fashion and luxury clothing. We curate the finest collection of
                contemporary and classic pieces to elevate your style and express your unique personality.
              </p>
              <div className="flex gap-4">
                <Button variant="ghost" size="sm" className="text-white hover:text-amber-200 p-2">
                  <Facebook className="h-5 w-5" />
                </Button>
                <Button variant="ghost" size="sm" className="text-white hover:text-amber-200 p-2">
                  <Twitter className="h-5 w-5" />
                </Button>
                <Button variant="ghost" size="sm" className="text-white hover:text-amber-200 p-2">
                  <Youtube className="h-5 w-5" />
                </Button>
                <Button variant="ghost" size="sm" className="text-white hover:text-amber-200 p-2">
                  <Instagram className="h-5 w-5" />
                </Button>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <div className="space-y-2">
                <Link href="/about" className="block text-amber-100 hover:text-white text-sm">
                  About Us
                </Link>
                <Link href="/contact" className="block text-amber-100 hover:text-white text-sm">
                  Contact Us
                </Link>
                <Link href="/careers" className="block text-amber-100 hover:text-white text-sm">
                  Career
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Customer Services</h4>
              <div className="space-y-2">
                <Link href="/profile" className="block text-amber-100 hover:text-white text-sm">
                  My Account
                </Link>
                <Link href="/track" className="block text-amber-100 hover:text-white text-sm">
                  Track Your Order
                </Link>
                <Link href="/returns" className="block text-amber-100 hover:text-white text-sm">
                  Return
                </Link>
                <Link href="/faq" className="block text-amber-100 hover:text-white text-sm">
                  FAQ
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Our Information</h4>
              <div className="space-y-2">
                <Link href="/privacy" className="block text-amber-100 hover:text-white text-sm">
                  Privacy
                </Link>
                <Link href="/terms" className="block text-amber-100 hover:text-white text-sm">
                  User Terms & Condition
                </Link>
                <Link href="/return-policy" className="block text-amber-100 hover:text-white text-sm">
                  Return Policy
                </Link>
              </div>

              <div className="mt-6 space-y-2">
                <h4 className="font-semibold">Contact Info</h4>
                <p className="text-amber-100 text-sm">+234 703 865 4053</p>
                <p className="text-amber-100 text-sm">hello@luxuryjeff.com</p>
                <p className="text-amber-100 text-sm">
                  8502 Preston Rd.
                  <br />
                  Inglewood, Maine 98380
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-amber-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-amber-100 text-sm">Copyright © 2025 Luxury Jeff. All Rights Reserved.</p>
            <div className="flex gap-4 mt-4 md:mt-0">
              <Button variant="ghost" size="sm" className="text-amber-100 hover:text-black">
                English <ChevronRight className="ml-1 h-4 w-4" />
              </Button>
              <Button variant="ghost" size="sm" className="text-amber-100 hover:text-black">
                NGN <ChevronRight className="ml-1 h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
